var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex align-center",
      class: {
        "justify-end": !_setup.isMobile,
      },
      attrs: { "data-qa": "analysis_price" },
    },
    [
      _c(
        "div",
        {
          staticClass: "text-success--text text-subtitle-1 mr-1",
          attrs: { "data-qa": "analysis_price_discount" },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.getFormattedPrice(_vm.price_with_discount)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-body-2 text-secondary--text text-decoration-line-through",
          attrs: { "data-qa": "analysis_price_original" },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_setup.getFormattedPrice(_vm.price)) + "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }